<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
      <modal-link modal-id="How to Use" :content-list="pageContent"  :image-color="'white'" :image-size="'large'"></modal-link>{{ title }}
      <div class="ml-auto">
        <i v-show="this.$root.getShowMenuIcon() && this.$root.getShowHeaderMenu()" class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
        <i v-show="this.$root.getShowMenuIcon() && !this.$root.getShowHeaderMenu()" class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
      </div>
    </div>
    <saved-card-menu :entry-client-object="clientObject" :original-saved-cards="clientChartsBySurvey" set-type="survey" view-type="menu"></saved-card-menu>
    <div class="response-rates"  v-show="!isInsiderUser">
      <div class="container pt-2">
        <!-- Chart Criteria -- Start -->      
        <div class="show-hide-links">
            <div class="col-4 mt-2 pl-0">
              <div class="chart-segment-options">
                <modal-link modal-id="Period/Group Options For Response Rates" :content-list="pageContent"></modal-link>
                <a href="#" v-show="!displayChartCriteriaPeriod" @click="toggleChartCriteriaPeriod">Show Period/Group Options<i class="fa fa-chevron-down ml-1"></i></a>
                <a href="#" v-show="displayChartCriteriaPeriod" @click="toggleChartCriteriaPeriod">Hide Period/Group Options<i class="fa fa-chevron-up ml-1"></i></a>
              </div>
            </div>
            <div class="col-5 mt-2">
              <div class="chart-segment-options">
                <modal-link modal-id="Segment Options For Response Rates" :content-list="pageContent"></modal-link>
                <a href="#" v-show="!displayChartCriteriaSegments" @click="toggleChartCriteriaSegments">Show Segment Options<i class="fa fa-chevron-down ml-1"></i></a>
                <a href="#" v-show="displayChartCriteriaSegments" @click="toggleChartCriteriaSegments">Hide Segment Options<i class="fa fa-chevron-up ml-1"></i></a>
              </div>
            </div>
          </div>
        <div  class="form-row">
          <div  class="col-4 mt-2 chart-criteria-border">
            <div v-show="displayChartCriteriaPeriod" class="chart-criteria-row">
              <div class="chart-criteria-label-column">
                <label class="sub-heading-label pt-1 my-auto">Periods</label>
              </div>
              <div class="chart-criteria-field-column">
                <multiselect
                  ref="periodsSelect"
                  v-model="periods"
                  :options="period_options"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :max-height="250"
                  select-label=""
                  deselect-label=""
                  selected-label=""
                  placeholder="Select"
                  label="chartDisplayName"
                  name="multi-period"
                  track-by="clientTimePeriodId"
                  @select="selectPeriod"
                  @remove="removePeriod"                    
                  :preselect-first="false"
                >
                  <template #option="props">
                    <span class="checkbox-label" @click.self="select(props.option)">
                      <input name="multi-period" class="mr-1" type="checkbox" v-model="props.option.checked" @focus.prevent />
                      {{ props.option.chartDisplayName }}
                    </span>
                  </template>
                </multiselect>
              </div>
            </div>
            <div v-show="displayChartCriteriaPeriod" class="chart-criteria-row">
              <div class="chart-criteria-label-column"></div>
              <div class="chart-criteria-field-column">
                <div class="form-group mb-1">
                  <input
                    id="useTTMAsStartDate"
                    name="useTTMAsStartDate"
                    type="checkbox"
                    true-value="Y"
                    false-value="N"
                    v-model="useTTMAsStartDate"
                    @click="saveCheckboxValue($event, 'Use TTM as Data Start Date', 'use_ttm_as_data_start_date', true)"
                  />
                  <span class="ml-1 mr-1">Use TTM as Data Start Date</span>
                </div>
                <div class="form-group mb-0">
                  <input
                    id="includePartialResponses"
                    name="includePartialResponses"
                    type="checkbox"
                    true-value="Y"
                    false-value="N"
                    v-model="includePartialResponses"
                    @click="saveCheckboxValue($event, 'Include Partial Responses', 'include_partial_responses', true)"
                  />
                  <span class="ml-1 mr-1">Include Partial Responses</span>
                </div>
              </div>
            </div>
            <div v-show="displayChartCriteriaPeriod" class="chart-criteria-row">
              <div class="chart-criteria-label-column">
                <label for="surveyGroup" class="sub-heading-label pt-1 my-auto">Group</label>
              </div>
              <div class="chart-criteria-field-column">
                <select
                  id="surveyGroup"
                  name="surveyGroup"
                  class="custom-select shadow w-100"
                  :disabled="disableChartCriteriaWidgets"
                  v-on:change="saveValue($event, 'Survey Group', 'survey_group', true);setUseEqualWeight();"
                  v-model="surveyGroup"
                >
                  <option value="">None</option>
                  <option v-for="(option, idxSurveyGroupOptions) in survey_group_options" v-bind:value="option.value" v-bind:key="idxSurveyGroupOptions">
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div v-show="displayChartCriteriaPeriod" class="chart-criteria-row">
              <div class="chart-criteria-label-column"></div>
              <div class="chart-criteria-field-column">
                <input
                  id="showPublicGroups"
                  name="showPublicGroups"
                  type="checkbox"
                  true-value="Y"
                  false-value="N"
                  v-model="showPublicGroups"
                  @click="saveCheckboxValue($event, 'Show Public Groups', 'show_public_groups', true)"
                />
                <span class="ml-1 mr-1">Show Public Groups</span>
              </div>
            </div>
          </div>
          <div  class="col-5 mt-2">
            <div v-show="displayChartCriteriaSegments" class="segments row no-gutters">
              <div v-for="(chartCriteria, idxSegments) in segments" v-bind:key="idxSegments" class="col-lg-6 col-sm-12 pt-1 pb-1">
                <chart-criteria-option
                  placeholder="Select"
                  option-type="multiselect"
                  label-class="sub-heading-label"
                  v-bind:option-object="chartCriteria"
                  :resetOption="resetOption"
                  :chartTitle="chart.title"
                  :surveyName="survey.name"
                  :content-list="pageContent"
                  @add="saveResultValue"
                ></chart-criteria-option>
              </div>
              <div class="d-none col-lg-4 col-sm-12">
                <div class="form-group">
                  <label for="survey_location" class="control-label pt-1 pr-1 my-auto">Location</label>
                  <a class="mr-1" href="#" @click="showPopup">
                    (Click to View Counts)                        
                  </a>
                  <treeselect
                    v-model="surveyLocation"
                    :multiple="true"
                    :alwaysOpen="false"
                    :show-count="false"
                    :default-expand-level="1"
                    :options="survey_location_options"
                    :append-to-body="true"
                    :required="false"
                    :clearable="false"
                    :maxHeight="400"
                    name="survey_location"
                    placeholder="Select"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-sm-12 pt-1 pb-1">
                <div class="d-none chart-criteria-row">
                    <div class="chart-criteria-label-column">
                      <label for="word" class="" style="color: #2f5eb3">Word</label>
                    </div>
                    <div class="col-9">
                      <Treeselect
                            :model-value="words"
                            @update:modelValue="onInputWords"
                            :is-independent-nodes="true"
                            :is-single-select="false"
                            :alwaysOpen="false"
                            :show-count="false"
                            :default-expand-level="1"
                            :options="word_options"
                            :append-to-body="true"
                            :required="false"
                            :clearable="false"
                            :maxHeight="400"
                            name="word"
                            placeholder="Select"
                          />
                    </div>
                </div>
              </div>                  
            </div>
          </div>
        </div>  
        <!-- Chart Criteria -- End -->      
        <div class="row no-gutters">
          <div class="btn-group-horizontal pb-2 pt-2" role="group">
            <button type="submit" class="btn btn-primary mr-3" @click="getResponseRates(false, false, 'generate')" :disabled="this.$root.getLoading()">
              <span>Generate</span>
              <span v-show="this.$root.getLoading() && responseRatesLoadingButton == 'generate'" class="spinner-border spinner-border-sm"></span>
            </button>
            <button type="submit" class="btn btn-primary mr-3" @click="resetChartCriteria">Reset</button>
            <button id="save_chart" class="btn btn-primary" type="button" @click="$modal.show('save-chart-confirmation')" :disabled="disableSaveAsCardButton">Save as Card</button>
          </div>
          <div class="pb-2 d-none" role="group">
            <button type="button" class="btn btn-primary" @click="scrollToChartOptions">Chart</button>
          </div>
        </div>
      </div>      
      <div v-if="getDisplayView() && displayResponseRatesTable" class="chart-header-container d-flex" style="justify-content: space-between;">
          <div class="d-flex title" style="padding-left: 0 !important;">
            <h4 class="text-primary mt-1 mb-0">
                Respondent Rates
            </h4>
          </div>   
          <div v-show="getDisplayView()" class="form-group form-inline align-items-center  mb-0 pr-3">
            <input type="checkbox" id="required" name="required" v-model="showCounts" true-value="Y" false-value="N" />
            <label for="required" class="control-label pl-1" style="color: black">Show Counts</label>
          </div>    
      </div>
      <div v-if="getDisplayView() && displayResponseRatesTable" id="response-rates-title-and-chart" class="ml-5 title-and-chart d-flex">
        <div v-show="getDisplayView()" id="response-rates-data-container">
          <table :id="responseRatesTable.id" :key="responseRatesRequestId" :class="responseRatesTable.class" data-turbolinks="false" width="auto">          
            <thead>
              <tr>
                <th
                  v-for="(tableHeader, idxTableHeader) in this.responseRatesData.tableHeader"
                  v-bind:key="idxTableHeader"
                  v-bind:class="[tableHeader.hasOwnProperty('headerClass') ? tableHeader.headerClass : 'base-column']"
                >
                  <span>
                    {{ tableHeader.data }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idxRows) in this.responseRatesData.rowsMap.rows" v-bind:key="idxRows">
                <td v-for="(needRow, idxNeedsRow) in row" v-bind:key="idxNeedsRow" v-bind:class="[needRow.hasOwnProperty('dataClass') ? needRow.dataClass : 'base-column']">
                  <button
                    v-if="isChartButtonColumn(needRow)"
                    type="button"
                    class="btn btn-primary"
                    @click="scrollToChartOptions(getChartButtonQuestionLabel(needRow))"
                  >
                    Chart
                  </button>
                  <span v-else v-html="displayData(needRow)"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div ref="chartOptionsToggle" class="show-more-chart-criteria">
        <a href="#" v-show="!displayChartOptions" @click.prevent="toggleChartOptions">Show Chart Options<i class="fa fa-chevron-down ml-1"></i></a>
        <a href="#" v-show="displayChartOptions" @click.prevent="toggleChartOptions">Hide Chart Options<i class="fa fa-chevron-up ml-1"></i></a>
      </div>
      <div v-show="displayChartOptions" class="row mt-3 ml-5 response-rates-options-row">
        <div class="col-3 response-rates-options-column">
          <div class="d-flex"><h4 class="response-rates-title text-primary mr-1">Chart Data</h4><modal-link modal-id="Chart Data" :content-list="pageContent"></modal-link></div>
          <response-rate-segment-question ref="segmentQuestion" 
                :input-segment-questions="segmentQuestions"
                :input-question-label="eChartCriteria.questionLabel" 
                :input-options-list="saveSelectedOptionsList" 
                @set-segment-question="setSegmentQuestion"/>
          <div class="btn-group-horizontal pb-2 pt-2" role="group">
            <button type="button" class="btn btn-primary mr-3" @click="getResponseRates(false, true, 'draw')" :disabled="disableDraw || this.$root.getLoading()">
              <span>Draw</span>
              <span v-show="this.$root.getLoading() && responseRatesLoadingButton == 'draw'" class="spinner-border spinner-border-sm"></span>
            </button>
          </div>
        </div>
        <response-rate-chart-buttons ref="chartButtons" :input-number-of-waves="periods.length" :input-e-chart-type="eChartCriteria.eChartType" 
            :input-recalculate="eChartCriteria.recalculate"
            :input-show-labels="eChartCriteria.showLabels"
            :input-show-legend="eChartCriteria.showLegend"
            :input-show-tooltip="eChartCriteria.showTooltip"
            :input-color-palette-id="eChartCriteria.colorPaletteId"
            :input-display-order="eChartCriteria.displayOrder"
            :content-list="pageContent"
            @set-recalculate="setRecalculate"
            @set-display-order="setDisplayOrder"
            @set-chart="setChartType"
            @set-show-legend="setShowLegend"
            @set-show-tooltip="setShowTooltip"
            @set-color-palette="setColorPaletteId"
            @set-show-labels="setShowLabels"
        />
      </div>
      <div class="row mt-3 ml-5">
        <chart-display-skeleton v-show="generatingChart && displayChartOptions"/>
      </div>
      <div ref="responseRateChartContainer" v-show="getDisplayView() &&  displayChartOptions" class="row mt-3 ml-5">
        <response-rate-chart ref="responseRateChart"
                              v-show="getDisplayView() && hasChartRun && displayChartOptions"
                            :raw-data="responseRatesData" 
                            :is-saved-card="clientChart.clientChartId != 0"
                            :input-question-list="questionLabelList" 
                            :input-client-chart="clientChart"
                            :input-time-periods="timePeriods"
                            :input-time-period-name="singleWaveTimePeriodName"
                            :most-recent-time-period="mostRecentTimePeriod"
                            :e-chart-criteria="eChartCriteria"
                            @save-criteria="rebuildClientChart"/>
      </div>      
    </div>
    <div v-show="isInsiderUser" class="overlay" >
      <img class="overlay-inner" v-show="isInsiderUser" src="../../assets/img/overlap.png"  style="width: 50%"/>
    </div>
    <insights ref="insightsChart" :modal-name="'response-rates-chart'"
        :report-page-type-name="'Chart - Response Rates'" :entry-page-content="this.pageContentForReport"
        @saveReportPage="updateReportPages" @saveAllReportPages="saveAllReportPages"
        @saveClientChart="saveClientChart" />    
    <counts-by-location ref="countsByLocation" :period="currentPeriod"/>
    <vue-modal ref="save-chart-confirmation" name="save-chart-confirmation" :width="350" :height="200">
        <save-chart button-label="Save as Card" :chart-title="this.chart.title" :initial-client-chart="this.clientChart" @save="updateClientCharts" @closeModal="closeModal('save-chart-confirmation')"></save-chart>
    </vue-modal>
  </div>
</template>
<script>
import $ from "jquery";

import EChartsService from "../../services/echarts.service";
import PrintAndCopyService from "../../services/print.and.copy.service";
import TableService from "../../services/table.service";
import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";

import UserService from "../../services/user.service";
import GoogleService from "../../services/google.service";
import AdminService from "../../services/admin.service";
import ChartService from "../../services/chart.service";
import SurveyService from "../../services/survey.service";
import ContentService from "../../services/content.service";
import ReportService from "../../services/report.service";
import ClientService from "../../services/client.service";
import ContentMixins from "../../mixins/ContentMixins.vue";
import RespondentMixins from "../../mixins/RespondentMixins.vue";
import ChartCriteriaMixins from "../../mixins/ChartCriteriaMixins.vue";
import ChartCompanyMixins from "../../mixins/ChartCompanyMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import CountsByLocation from "../../modals/CountsByLocation.vue";
import ResponseRateChart from "../echarts/ResponseRateChart.vue";
import SaveChart from "../../components/chart/SaveChart.vue";
import ChartCriteriaOption from "../../components/chart/ChartCriteriaOption.vue";
import ResponseRateChartButtons from "../../components/echarts/ResponseRateChartButtons.vue";
import ResponseRateSegmentQuestion from "../../components/echarts/ResponseRateSegmentQuestion.vue";
import Multiselect from "vue-multiselect";
export default {
  name: "ResponseRates",
  mixins: [ContentMixins, RespondentMixins, DataTableMixins, ChartCriteriaMixins, ChartCompanyMixins],
  components: {
    CountsByLocation,ResponseRateChart,SaveChart,ChartCriteriaOption,ResponseRateChartButtons,ResponseRateSegmentQuestion,Multiselect,ChartDisplaySkeleton
  },
  props: {},
  data() {
    return {
      initialPageLoad: true,
      displayChartOptions: false,
      displayResponseRatesTable: false,
      disableDraw: false,
      pageNumber: 9,
      showCounts: 'N',
      title: "Rates",
      chart: {
        title: "Respondent Rates",
        typeName: "response-rates"
      },
      responseRatesData: {
        tableHeader: [],
        rowsMap: {
          rows: []
        }
      },
      hasChartRun: false,
      questionLabelList: [],
      segmentQuestions: [],
      positiveClass: "text-success",
      negativeClass: "text-danger",
      baseClass: "base-column",
      notActiveClass: "",
      currentPeriod: "0",
      responseRatesTable: {
        id: "response-rate-table",
        class: "table display wrap row-border table-hover",
        columns: [],
        configuration: {
          dom: '<"title-and-table-left"<"table-header"><B>>frtip',
          searching: false,
          paging: false,
          select: true,
          processing: false,
          responsive: false,
          destroy: true,
          info: false,
          ordering: true,
          keys: true,
          sort: false,
          bSortable: false,
          bSort: false,
          buttons: [],
          columnDefs: [
            { orderSequence: ["desc", "asc"], targets: ["_all"] },
            { targets: [0], visible: true },
            {
              targets: "_all",
              width: "50px"
            }
          ]
        }
      },
      snapModalContent: PrintAndCopyService.getSnapMessage(),
      period_options: [],
      periods: [],
      timePeriods: [],
      includePartialResponses: "Y",
      useTTMAsStartDate: "N",
      eChartCriteria: this.getDefaultEChartCriteria(),
      saveSelectedOptionsList: [],
      mostRecentTimePeriod: "",
      responseRatesRenderTimeout: null,
      responseRatesRequestId: 0,
      responseRatesLoadingButton: "",
    };
  },
  computed: {
    disableSaveAsCardButton: function(){
      if (this.isW5OUser || this.isInsiderUser) {
        return true;
      }
      if (this.clientChart.clientChartId != 0 ){
        return false;
      }
      if (!this.disableDraw) {
        return true;
      }
      return false;
    },
    singleWaveTimePeriodName: function(){
      if (this.period_options.length > 0 && this.periods.length > 0) {
        let singleWaveTimePeriodId = this.periods[0].clientTimePeriodId;
        let period = this.period_options.find(x => x.clientTimePeriodId == singleWaveTimePeriodId);
        if (typeof period != "undefined") {
          return period.chartDisplayName;
        }
      }
      return "";
    },
  },
  methods: {
    async getPageContent(pageName) {
      ContentService.getPageContent(pageName, this.getPageContentCallBack, this);
    },    
    getPageContentCallBack(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.pageContent = [...this.pageContent, ...response.data.data];
      }
    },    
    toggleChartOptions() {
      let label = this.displayChartOptions ? "close" : "open";
      GoogleService.logClickEvent("Chart Options Section Toggle", label, 0, this);         
      this.displayChartOptions = !this.displayChartOptions;
    },
    scrollToChartOptions(questionLabel = "") {
      if (typeof this.$refs.segmentQuestion != "undefined") {
        let selectedQuestion = false;
        if (questionLabel != "") {
          selectedQuestion = this.$refs.segmentQuestion.selectQuestionAndAllOptions(questionLabel);
        }
        if (!selectedQuestion) {
          this.$refs.segmentQuestion.selectAllOptions();
        }
      }
      if (!this.displayChartOptions) {
        this.displayChartOptions = true;
      }
      this.$nextTick(() => {
        if (typeof this.$refs.chartOptionsToggle != "undefined") {
          this.$refs.chartOptionsToggle.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    scrollToResponseRateChart() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (typeof this.$refs.responseRateChartContainer != "undefined") {
            this.$refs.responseRateChartContainer.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 100);
      });
    },

    displayData(needRow) {
      return this.showCounts == "Y" ? (needRow.recordCount == 0 ? needRow.data : needRow.recordCount) : needRow.data;
    },
    closeModal(name) {
      if(this.$refs[name] != null) {
        this.$refs[name].visible = false;
      }
    },
    selectPeriod(period) {
      var match = this.periods.find(x => Number(x.clientTimePeriodId) === Number(period.clientTimePeriodId));
      if (typeof match != "undefined") {
        period.checked = true;
      }   
    },
    removePeriod(period) {
      if (typeof period !== "undefined") {
          period.checked = false;
          // remove from list of existing timePeriods
          var match = this.timePeriods.find(x => x === period.chartDisplayName);
          if (typeof match != "undefined") {
            var index = this.timePeriods.indexOf(match);
            if (index > -1) {
              this.timePeriods.splice(index, 1);
            }
          }
      }      
    },
    resetPeriods() {
      for (let i = 0; i < this.period_options.length; i++) {
        this.period_options[i].checked = false;
      }
    },
    setSelectedPeriodsByIds(periodIds) {
      if (!Array.isArray(periodIds) || periodIds.length <= 0) {
        return;
      }
      this.periods = [];
      for (let i = 0; i < periodIds.length; i++) {
        let periodId = periodIds[i];
        let period = this.period_options.find(x => Number(x.clientTimePeriodId) == Number(periodId));
        if (typeof period != "undefined") {
          period.checked = true;
          this.periods.push(period);
        }
      }
      this.timePeriods = this.periods.map(period => period.displayName);
    },
    setDisplayOrder(inputDisplayOrder){
      this.eChartCriteria.displayOrder = inputDisplayOrder;
      this.$refs.responseRateChart.processChart(this.hasChartRun,this.eChartCriteria);
    },      
    setRecalculate(inputRecalculate){
      this.eChartCriteria.recalculate = inputRecalculate;
      this.$refs.responseRateChart.processChart(this.hasChartRun,this.eChartCriteria);
    },
    setSegmentQuestion(selectedSegmentQuestion) {
      let questionChanged = this.eChartCriteria.questionLabel != "" && this.eChartCriteria.questionLabel != selectedSegmentQuestion.label;
      if (questionChanged) {
        this.resetResponseRateChart();
      }
      this.eChartCriteria.questionLabel = selectedSegmentQuestion.label;
      this.eChartCriteria.selectedOptionsList = JSON.parse(JSON.stringify(selectedSegmentQuestion.optionsList));
      this.$refs.responseRateChart.processChart(this.hasChartRun,this.eChartCriteria);
    },
    setChartType(inputEChartType, inputRecalculate){
      this.eChartCriteria.eChartType = inputEChartType;
      this.$refs.responseRateChart.processChart(this.hasChartRun,this.eChartCriteria);
    },
    setColorPaletteId(inputColorPalette){
      this.eChartCriteria.colorPaletteId = inputColorPalette;
      this.$refs.responseRateChart.processChart(this.hasChartRun,this.eChartCriteria);
    },
    setShowLegend(inputShowLegend){
      this.eChartCriteria.showLegend = inputShowLegend;
      this.$refs.responseRateChart.processChart(this.hasChartRun,this.eChartCriteria);
    },
    setShowTooltip(inputShowTooltip){
      this.eChartCriteria.showTooltip = inputShowTooltip;
      this.$refs.responseRateChart.processChart(this.hasChartRun,this.eChartCriteria);
    },
    setShowLabels(inputShowLabels){
      this.eChartCriteria.showLabels = inputShowLabels;
      this.$refs.responseRateChart.processChart(this.hasChartRun,this.eChartCriteria);
    },
    async snapChart(displayLegend, snapContainerId) {
      PrintAndCopyService.initializeSnapChart(displayLegend, snapContainerId, this); 
    },
    showCountsByLocation(period){
      this.currentPeriod = period;
      this.$refs.countsByLocation.loadData();
      this.$modal.show("counts-by-location");

    },
    clearTable() {
      this.clearResponseRatesRenderTimeout();
      if (typeof this.responseRatesTable.dataTable != "undefined") {
        this.responseRatesTable.dataTable.destroy();
        this.responseRatesTable.dataTable = undefined;
      }      
    },
    clearResponseRatesRenderTimeout() {
      if (this.responseRatesRenderTimeout != null) {
        clearTimeout(this.responseRatesRenderTimeout);
        this.responseRatesRenderTimeout = null;
      }
    },
    resetResponseRatesDataElements() {
      this.responseRatesData = {
        tableHeader: [],
        rowsMap: {
          rows: []
        }
      };
      this.questionLabelList = [];
      this.segmentQuestions = [];
      this.timePeriods = [];
      this.saveSelectedOptionsList = [];
      this.mostRecentTimePeriod = "";
      this.displayResponseRatesTable = false;
      this.displayChartOptions = false;
      this.generatingChart = false;
      this.disableDraw = false;
      this.hasChartRun = false;
      this.initialPageLoad = true;
      this.showCounts = "N";
      this.currentPeriod = "0";
      this.includePartialResponses = "Y";
      this.useTTMAsStartDate = "N";
      this.responseRatesLoadingButton = "";
    },
    resetResponseRateChart() {
      this.generatingChart = false;
      this.disableDraw = false;
    },
    rebuildTable() {
      // Toggle between counts/percentages requires DataTables to be rebuilt so DOM reflects Vue render.
      if (typeof this.responseRatesTable.dataTable == "undefined") {
        return;
      }
      this.responseRatesTable.dataTable.destroy();
      this.responseRatesTable.dataTable = undefined;
      this.$nextTick(() => {
        const tableSelector = `#${this.responseRatesTable.id}`;
        if (document.querySelector(tableSelector)) {
          this.responseRatesTable.dataTable = $(tableSelector).DataTable(this.responseRatesTable.configuration);
        }
      });
    },
    isChartButtonColumn(needRow) {
      return needRow != null && needRow.dataClass == "chart-button-column";
    },
    getChartButtonQuestionLabel(needRow) {
      return needRow != null && typeof needRow.data != "undefined" ? needRow.data.toString().trim() : "";
    },
    configureResponseRatesTableButtons() {
      this.applyChartButtonExcelFormatter(this.responseRatesTable.configuration.buttons);
    },
    applyChartButtonExcelFormatter(buttons) {
      if (!Array.isArray(buttons)) {
        return;
      }
      buttons.forEach(button => {
        if (Array.isArray(button.buttons)) {
          this.applyChartButtonExcelFormatter(button.buttons);
        }
        if (typeof button.extend != "string" || button.extend.toLowerCase().indexOf("excel") < 0 || button.chartButtonExcelFormatterApplied) {
          return;
        }
        if (typeof button.exportOptions == "undefined") {
          button.exportOptions = {};
        }
        if (typeof button.exportOptions.format == "undefined") {
          button.exportOptions.format = {};
        }
        let bodyFormatter = button.exportOptions.format.body;
        button.exportOptions.format.body = function(data, row, column, node) {
          if (node != null && node.classList != null && node.classList.contains("chart-button-column")) {
            return "";
          }
          return typeof bodyFormatter == "function" ? bodyFormatter(data, row, column, node) : data;
        };
        button.chartButtonExcelFormatterApplied = true;
      });
    },
    isNumber(value) {
      return value != "--";
    },
    async getResponseRates(checkNumberOfWaves = false, scrollToChartAfterRender = false, responseRatesLoadingButton = "") {
      if (checkNumberOfWaves && this.periods.length <= 0) {
        let errorMessage = "At least one wave is required. Please select wave(s) to display this chart.";
        AdminService.displayErrorMessage({ text: errorMessage });
        this.disableDraw = false;
        return;
      }
      if (checkNumberOfWaves && this.eChartCriteria.selectedOptionsList.length <= 0) {
        let errorMessage = "At least one segment option is required. Please select one or more options to display this chart.";
        AdminService.displayErrorMessage({ text: errorMessage });
        this.disableDraw = false;
        return;
      }      
      if (this.$refs.chartButtons.verifyChartCriteria(this.eChartCriteria.eChartType)) {
        this.responseRatesLoadingButton = responseRatesLoadingButton;
        this.clearTable();
        this.generatingChart = true;
        this.displayResponseRatesTable = false;
        this.setDisplayView(false);
        this.$root.processServerRequest("Retrieving data");
        let params = this.buildClientChart(this.buildBaseCriteriaUrl);
        let responseRatesRequestId = ++this.responseRatesRequestId;
        await SurveyService.getResponseRates(params, response => this.getResponseRatesCallback(response, responseRatesRequestId, scrollToChartAfterRender), this);
        if (responseRatesRequestId != this.responseRatesRequestId) {
          this.responseRatesLoadingButton = "";
          return;
        }
        if (this.initialPageLoad == true) {
          this.initialPageLoad = false;
        } else {
          this.hasChartRun = true;
          //this.disableDraw = true;
        }
        this.rebuildClientChart(true);
        this.autoGenerateChartRun = false;
        this.saveSelectedOptionsList = [];
        this.responseRatesLoadingButton = "";
      } 
    },
    rebuildClientChart(rebuildClientChart) {
      let params = this.buildClientChart(this.buildBaseCriteriaUrl);
    },
    buildBaseCriteriaUrl() {
      let periodIds = this.periods.map(period => period.clientTimePeriodId);   
      let params = new URLSearchParams();
      params.append("clientCode", ClientService.getClientCode());
      params.append("surveyId", SurveyService.getSurveyId());
      params.append("userId", UserService.getUserId());
      params.append("periodIds", periodIds);
      params.append("surveyGroup", this.surveyGroup);
      params.append("questionLabel",this.eChartCriteria.questionLabel);
      params.append("includePartialResponses", this.includePartialResponses);
      params.append("useTTMAsStartDate", this.useTTMAsStartDate);
      params.append("hasChartRun",this.hasChartRun);
      params.append("displayOrder",this.eChartCriteria.displayOrder);
      params.append("eChartType",this.eChartCriteria.eChartType);
      params.append("recalculate",this.eChartCriteria.recalculate);
      params.append("colorPaletteId",this.eChartCriteria.colorPaletteId);
      let savedSelectedOptionsList = "";
      for (let i = 0; i < this.eChartCriteria.selectedOptionsList.length; i++) {
        savedSelectedOptionsList += this.eChartCriteria.selectedOptionsList[i] + ";";
      }
      savedSelectedOptionsList = savedSelectedOptionsList.substring(0, savedSelectedOptionsList.length - 1);
      params.append("selectedOptionsList",savedSelectedOptionsList);
      
//      params.append("selectedOptionsList",this.eChartCriteria.selectedOptionsList);
      params.append("showLegend",this.eChartCriteria.showLegend);
      params.append("showLabels",this.eChartCriteria.showLabels);
      params.append("showTooltip",this.eChartCriteria.showTooltip);
      return this.buildCriteriaUrl(params);
    },
    buildClientChart: function(buildURLFunction) {
      let useSaveParameters = typeof this.clientChart.criteria != undefined && this.clientChart.criteria != "" && this.autoGenerateChartRun;
      const params = useSaveParameters ? new URLSearchParams(this.clientChart.criteria) : buildURLFunction();
      this.clientChart.criteria = params.toString();
      this.clientChart.chartTypeId = this.chartType.chartTypeId;
      this.clientChart.clientId = this.clientId;
      if (this.periods.length > 0) {
        this.clientChart.clientTimePeriodId = this.periods[0].clientTimePeriodId;
      }
      if (typeof this.clientChart.displayType != "undefined" && typeof this.$refs.chartCriteria != "undefined") {
        this.clientChart.displayType = this.$refs.chartCriteria.$data.displayType;
      } else {
        this.clientChart.displayType = "response-rates";
      }
      if (typeof this.saveClientChartObject.name == "undefined" || this.saveClientChartObject.name == "") {
        let selectedQuestion = this.questionLabelList.find(x => x.label == this.eChartCriteria.questionLabel);
        if (typeof selectedQuestion != "undefined") {
          this.clientChart.name = selectedQuestion.segmentLabel;
        } else {
          this.clientChart.name = this.chart.title + " Analytics";
        }
      }
      return params;
    },
    processAutoGenerateChart() {
      let skipValidation = this.autoGenerateChartRun;
      if (this.autoGenerateChartRun) {
        if (typeof this.clientChart != "undefined") {
          if (typeof this.clientChart.criteria != "undefined" && this.clientChart.criteria != "") {
            let criteriaParameters = this.clientChart.criteria.split("&");
            for (let criteriaIndex = 0; criteriaIndex < criteriaParameters.length; criteriaIndex++) {
              let criteria = criteriaParameters[criteriaIndex];
              this.processSavedChartCriteria(criteria);
            }
          }
        }
      }
      this.$refs.chartButtons.loadChart(skipValidation,this.eChartCriteria.eChartType);
      this.getResponseRates(false);
    },            
    getResponseRatesCallback(response, responseRatesRequestId = this.responseRatesRequestId, scrollToChartAfterRender = false) {
      if (responseRatesRequestId != this.responseRatesRequestId) {
        return;
      }
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.clearResponseRatesRenderTimeout();
        this.displayResponseRatesTable = false;
        this.setDisplayView(true);
        this.criteriaResultsList = (typeof response.data.data.criteriaList != "undefined") ? AdminService.removeByName(response.data.data.criteriaList, "Competitor") : [];
        this.responseRatesData = response.data.data.responseRatesData;
        this.questionLabelList = this.responseRatesData.questionLabelList;
        this.segmentQuestions = response.data.data.segmentQuestions;
        this.mostRecentTimePeriod = response.data.data.mostRecentTimePeriod;
        this.timePeriods = response.data.data.timePeriods;
        if (this.periods.length <= 0 && Array.isArray(response.data.data.selectedClientTimePeriodIds)) {
          this.setSelectedPeriodsByIds(response.data.data.selectedClientTimePeriodIds);
        }
        this.responseRatesTable.configuration.order = [];
        let vm = this;
        this.responseRatesRenderTimeout = setTimeout(() => {
          if (responseRatesRequestId != vm.responseRatesRequestId) {
            return;
          }
          vm.responseRatesRenderTimeout = null;
          vm.displayResponseRatesTable = true;
          vm.$nextTick(() => {
            if (responseRatesRequestId != vm.responseRatesRequestId) {
              return;
            }
            var tableSelector = "#" + vm.responseRatesTable.id;
            if ($(tableSelector).length <= 0) {
              return;
            }

            let isSavedCard = vm.clientChart.clientChartId != 0;
            $.extend(vm.responseRatesTable.configuration, TableService.getTableButtons(vm, "response-rates-data-container",undefined, undefined, true, "Respondent Rates"),isSavedCard);
            vm.configureResponseRatesTableButtons();
            vm.responseRatesTable.dataTable = $("#" + vm.responseRatesTable.id).DataTable(vm.responseRatesTable.configuration);
            if (vm.eChartCriteria.questionLabel == ""){
              vm.eChartCriteria.questionLabel = vm.questionLabelList.length > 0 ? vm.questionLabelList[0].label : "";
            }
            let searchableQuestionLabel = vm.questionLabelList.find(x => x.label == vm.eChartCriteria.questionLabel);
            if (vm.hasChartRun &&  typeof searchableQuestionLabel == "undefined"){
              let errorMessage = "The segment selected is not included in any of the surveys in the group selected. Please select a different segment and/or group";
              AdminService.displayErrorMessage({ text: errorMessage });
              vm.disableDraw = false;
              return;            
            }
            vm.$refs.responseRateChart.processChart(true,vm.eChartCriteria);
            let responseRatesHeaderContainer = $("#response-rates-data-container")
            .find(".title-and-table-left");

            if (responseRatesHeaderContainer.length > 1) {
              responseRatesHeaderContainer[0].remove();
            }               
            $("#response-rates-title-and-chart").addClass("chart-wrapper");            
            vm.generatingChart = false;
            vm.displayChartOptions = true;
            if (scrollToChartAfterRender) {
              vm.scrollToResponseRateChart();
            }
          });
        }, 1500);
      } else if (statusCode == 201) {
        AdminService.displaySuccessMessage({ text: response.data.message },true);
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    loadData: function() {
      if (!this.isW5OUser){
        this.initializeData();
      }
    },
    async initializeData() {
      this.responseRatesRequestId++;
      this.clearResponseRatesRenderTimeout();
      this.setDisplayView(false);
      if (!this.$parent.autoGenerateChartRun) {
        this.criteriaResults = [];
        this.resetChartCriteria(false);
      }
      this.clearTable();
      this.resetResponseRatesDataElements();
      await ClientService.getPredictiveAnalyticsOptions(this.getChartCriteriaOptionsCallback, this);
    },
    getChartCriteriaOptionsCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.period_options = response.data.data.clientTimePeriods;
        let additionalOptions = response.data.data.additionalOptions;
        this.criteriaResults = [];
        for (var i in additionalOptions) {
          this.criteriaResults.push(additionalOptions[i]);
        }
        this.surveyGroupList = response.data.data.surveyGroupList;
        this.segments = ChartService.getSegments(this.criteriaResults);
        this.segmentQuestions = response.data.data.segmentQuestions;
        this.eChartCriteria.questionLabel = this.segmentQuestions.length > 0 ? this.segmentQuestions[0].label : "";
        this.survey_group_options = this.getSurveyGroupOptions();
        this.processAutoGenerateChart();
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },    
    getDefaultEChartCriteria: function(){
      let defaultEChartCriteria = {
        recalculate: true,
        displayOrder: "question",
        showTooltip: true,
        selectedOptionsList: [],
        questionLabel: "",
      };
      $.extend(defaultEChartCriteria, EChartsService.getBaseEChartCriteria());
      if (typeof this.questionLabelList != "undefined" && this.questionLabelList.length > 0){
        defaultEChartCriteria.questionLabel = this.questionLabelList[0].label;
      }
      return defaultEChartCriteria;
    },
    resetChartCriteria: function(resetAutoGenerateChartRun = true) {
      this.resetPeriods();
      this.disableDraw = false;
      this.resetOption = !this.resetOption;
      this.surveyGroup = "";
      if (resetAutoGenerateChartRun == true){
        this.autoGenerateChartRun = false;
      }
      this.periods = [];
      this.includePartialResponses = "Y";
      this.useTTMAsStartDate = "N";
      this.resetCriteriaResults();
      this.hasChartRun = false;
      GoogleService.logResetCriteria(this.chart.title, "", this.survey.name, this);
      this.eChartCriteria = JSON.parse(JSON.stringify(this.getDefaultEChartCriteria()));
      this.$refs.segmentQuestion.resetSegmentQuestion();
    },    
    processSavedChartCriteria(criteria) {
      let criteriaParameters = criteria.split("=");
      let defaultParameter = criteriaParameters[0];
      let defaultValue = criteriaParameters[1];
      let defaultCriteria = this.findCriteriaByParameter(defaultParameter);
      if (defaultParameter == "questionLabel"){
        let questionLabel = "";
        try {
          questionLabel = JSON.parse(defaultValue);
        } catch (e) {
          questionLabel = decodeURIComponent(defaultValue).replace(/\+/g, " ");
        }        
        this.eChartCriteria.questionLabel = questionLabel;       
      }
      if (defaultParameter == "hasChartRun"){
        this.hasChartRun =  defaultValue == "true";
        this.displayChartOptions = this.hasChartRun;        
      }
      if (defaultParameter == "periodIds"){
        let savedPeriodIds;
        try {
          savedPeriodIds = JSON.parse(defaultValue);
        } catch (e) {
          var decodedSavedPeriodIds = decodeURIComponent(defaultValue).replace(/\+/g, " ");
          savedPeriodIds = decodedSavedPeriodIds.split(',');
        }
        if (typeof savedPeriodIds == "number"){
          savedPeriodIds = [savedPeriodIds];
        }
        if (!Array.isArray(savedPeriodIds)) {
          savedPeriodIds = [savedPeriodIds];
        }
        this.setSelectedPeriodsByIds(savedPeriodIds);
      }
      if (defaultParameter == "displayOrder"){
        let displayOrder = "";
        try {
          displayOrder = JSON.parse(defaultValue);
        } catch (e) {
          displayOrder = decodeURIComponent(defaultValue).replace(/\+/g, " ");
        }        
        this.eChartCriteria.displayOrder = displayOrder;
      }
      
      if (defaultParameter == "colorPaletteId"){
        let colorPaletteId = "";
        try {
          colorPaletteId = JSON.parse(defaultValue);
        } catch (e) {
          colorPaletteId = decodeURIComponent(defaultValue).replace(/\+/g, " ");
        }        
        if (!isNaN(colorPaletteId)) {
          this.eChartCriteria.colorPaletteId = Number(colorPaletteId);
        }        
      }
      if (defaultParameter == "segments") {
        let currentSegments = this.segments;
        let savedSegments;
        try {
          savedSegments = JSON.parse(defaultValue);
        } catch (e) {
          var decodedDefaultValue = decodeURIComponent(defaultValue).replace(/\+/g, " ");
          savedSegments = $.parseJSON(decodedDefaultValue);
        }
        for (let currentSegmentsIndex = 0; currentSegmentsIndex < currentSegments.length; currentSegmentsIndex++) {
          let currentSegment = currentSegments[currentSegmentsIndex];
          for (let savedSegmentsIndex = 0; savedSegmentsIndex < savedSegments.length; savedSegmentsIndex++) {
            let savedSegment = savedSegments[savedSegmentsIndex];
            if (currentSegment.name == savedSegment.name) {
              currentSegment.values = savedSegment.values;
            }
          }
        }
      }      
      if (defaultParameter == "eChartType"){
        let eChartType = "";
        try {
          eChartType = JSON.parse(defaultValue);
        } catch (e) {
          eChartType = decodeURIComponent(defaultValue).replace(/\+/g, " ");
        }     
        this.eChartCriteria.eChartType = eChartType;   
      }
      if (defaultParameter == "recalculate"){
        let recalculate = "";
        try {
          recalculate = JSON.parse(defaultValue);
        } catch (e) {
          recalculate = decodeURIComponent(defaultValue).replace(/\+/g, " ");
        }   
        this.eChartCriteria.recalculate = recalculate || (recalculate == "true");   
      }
      if (defaultParameter == "showLegend"){
        let showLegend = "";
        try {
          showLegend = JSON.parse(defaultValue);
        } catch (e) {
          showLegend = decodeURIComponent(defaultValue).replace(/\+/g, " ");
        }   
        this.eChartCriteria.showLegend = showLegend || (showLegend == "true");   
      }
      if (defaultParameter == "showTooltip"){
        let showTooltip = "";
        try {
          showTooltip = JSON.parse(defaultValue);
        } catch (e) {
          showTooltip = decodeURIComponent(defaultValue).replace(/\+/g, " ");
        }   
        this.eChartCriteria.showTooltip = showTooltip || (showTooltip == "true");   
      }
      if (defaultParameter == "showLabels"){
        let showLabels = "";
        try {
          showLabels = JSON.parse(defaultValue);
        } catch (e) {
          showLabels = decodeURIComponent(defaultValue).replace(/\+/g, " ");
        }   
        this.eChartCriteria.showLabels = showLabels || (showLabels == "true");   
      }
      if (defaultParameter == "selectedOptionsList"){
        let selectedOptionsList;
        try {
          selectedOptionsList = JSON.parse(defaultValue);
        } catch (e) {
          var decodedSelectedOptionsList = decodeURIComponent(defaultValue).replace(/\+/g, " ");
          selectedOptionsList = decodedSelectedOptionsList.split(';');
          selectedOptionsList.filter(value => value != "");
        }      
        this.eChartCriteria.selectedOptionsList = JSON.parse(JSON.stringify(selectedOptionsList));
        this.saveSelectedOptionsList = JSON.parse(JSON.stringify(selectedOptionsList));
      }
      if (typeof defaultCriteria != "undefined") {
        let isSurveyGroup = defaultCriteria.parameterName == "survey_group" ? true : false;
        let isShowPublicGroups = defaultCriteria.parameterName == "show_public_groups" ? true : false;
        let isIncludePartialResponses = defaultCriteria.parameterName == "include_partial_responses" ? true : false;
        let isUseTTMAsStartDate = defaultCriteria.parameterName == "use_ttm_as_data_start_date" ? true : false;
        let updateValue = false;
        if (isShowPublicGroups) {
          this.showPublicGroups = defaultValue;
          this.survey_group_options = this.getSurveyGroupOptions();
        }
        if (isIncludePartialResponses) {
          this.includePartialResponses = defaultValue;
        }
        if (isUseTTMAsStartDate) {
          this.useTTMAsStartDate = defaultValue;
        }
        if (isSurveyGroup) {
          this.surveyGroup = defaultValue;
        }        
        this.saveResultValue(defaultValue, defaultCriteria.name, defaultCriteria.parameterName, updateValue);
      }
    },
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Chart - Response Rates") {
        this.$refs.insightsChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.reportPagesList);
        this.$refs.insightsChart.initializeInsights(this.clientChart);
        this.$modal.show(insightModalId);
      } 
    },
    saveAllReportPages() {
      this.saveReportPage("response-rates-chart","Chart - Response Rates",this.clientChart);
    },   
  },
  mounted() {
    this.getPageContent("Chart");
  },
  watch: {
    showCounts: function() {
      if (this.getDisplayView()) {
        this.rebuildTable();
      }
    },
    saveClientChartId: function() {
      if (this.saveClientChartId > 0) {
        this.processClientChart();
        this.loadData();
      }
    },
    periods: function() {
      this.disableDraw = false;
    },
    surveyGroup: function() {
      this.disableDraw = false;
    },
    showPublicGroups: function() {
      this.disableDraw = false;
    },
    includePartialResponses: function() {
      this.disableDraw = false;
    },
    useTTMAsStartDate: function() {
      this.disableDraw = false;
    },
  },
  
};
</script>
